import { setProblemAsCompleted, setLessonAsCompleted  } from "../../../../services/userService";



export function CheckCode(studentCode, output, checkboxes, user, lessonID) {

    // const expectedOutput1 =  /^Hello, Java!\nWelcome to programming\.\n$/;
    // const expectedOutput2 = /^Java is fun!$/;
    // const expectedOutput3 = /^12 \+ 8 = 20\n$/;
    // const expectedOutput4 = /^The sum of 5 and 10 is: 15\n$/;

    const expectedOutput1 =  /Hello, Java!\nWelcome to programming\.\n/;
    const expectedOutput2 = /Java is fun!/;
    const expectedOutput3 = /The number is: 42\n/;



    if (checkboxes.checkbox1 === false) {
        const testResult = expectedOutput1.test(output)
        if(testResult){
            setProblemAsCompleted( lessonID + "P1", user.uid);
            checkboxes.checkbox1 = testResult;
            // console.log("Problem 1 passed");
        }else{
            console.log("Test Failed for problem1: 'age' variable of type int is not declared correctly.");
        }


    }

    if (checkboxes.checkbox2 === false) {
        const testResult = expectedOutput2.test(output)
        if(testResult){
            setProblemAsCompleted(lessonID+"P2", user.uid);
            checkboxes.checkbox2 = testResult;
            // console.log("Problem 2 passed");
        }else{
            console.log("Test Failed for problem 2: 'age' variable of type int is not declared correctly.");
        }
    }

    if (checkboxes.checkbox3 === false) {
        const testResult = expectedOutput3.test(output)
        if(testResult){
            setProblemAsCompleted(lessonID +"P3", user.uid);
            checkboxes.checkbox3 = testResult;
            // console.log("Problem 3 passed");
        }else{
            console.log("Test Failed for problem 3: 'age' variable of type int is not declared correctly.");
        }
    }


    if(checkboxes.checkbox1 === true && checkboxes.checkbox2 === true && checkboxes.checkbox3 === true ){
        console.log("Passed the Lesson")
      //  setLessonAsCompleted(lessonID, user.uid);
    }

    return checkboxes;
}